import {
  Component,
  EventEmitter,
  Output,
  Input,
  OnInit,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-growth-revision-filter",
  templateUrl: "./growth-revision-filter.component.html",
  styleUrls: ["./growth-revision-filter.component.scss"],
})
export class GrowthRevisionFilterComponent implements OnInit {
  @Input() isIndustryPage;
  dataViewFilterVisible = false;
  popoverOpen = false;
  dataviewApplied = false;
  radioValue = "";
  checkOptions = [];
  dvErrMsg = "";
  invalidDataview = false;
  selectedDataView = "";
  @Input() dataview: any;
  @Input() disable = false;
  @Output() saveDataview = new EventEmitter();

  // constructor() {}

  ngOnInit() {
    if (this.isIndustryPage) {
      this.checkOptions = [
        { label: "Values", value: "values", checked: true },
        { label: "YoY%", value: "yoy", checked: false },
      ];
      this.selectedDataView = "Values";
    } else {
      this.checkOptions = [
        { label: "Values", value: "values", checked: true },
        { label: "YoY%", value: "yoy", checked: true },
      ];
      this.selectedDataView = "Values,YoY%";
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      this.isIndustryPage &&
      changes.dataview &&
      changes.dataview.previousValue !== changes.dataview.currentValue
    ) {
      if (this.dataview && this.dataview["view_by"][0] !== "revision") {
        this.radioValue = "";
        if (this.checkOptions.length !== 0) {
          for (let i = 0; i < 2; i++) {
            this.checkOptions[i].checked = this.dataview["view_by"].includes(
              this.checkOptions[i].value,
            )
              ? true
              : false;
          }
        }
        if (this.dataview["view_by"].length < 2) {
          this.selectedDataView =
            this.dataview["view_by"][0] === "values" ? "Values" : "YoY%";
        } else {
          this.selectedDataView = "Values,YoY%";
        }
      } else {
        for (let i = 0; i < 2; i++) {
          this.checkOptions[i].checked = false;
        }
        this.radioValue = this.dataview["revision"];
        switch (this.radioValue) {
          case "1y":
            this.selectedDataView = "&Delta; 1 year";
            break;
          case "2y":
            this.selectedDataView = "&Delta; 2 years";
            break;
          default:
            break;
        }
      }
    }
  }

  /**
   * This method handles the opening and closing of the growth revision filter popover.
   *
   * The popover can be closed either using the apply button or clicking outside on the page.
   * This method deals with both the scenarios.
   */
  popoverChange() {
    this.popoverOpen = !this.popoverOpen;
    if (this.popoverOpen) {
      this.dataviewApplied = false;
    }
    if (!this.popoverOpen && !this.dataviewApplied) {
      if (this.dataview && this.dataview["view_by"][0] !== "revision") {
        this.radioValue = "";
        for (let i = 0; i < 2; i++) {
          this.checkOptions[i].checked = this.dataview["view_by"].includes(
            this.checkOptions[i].value,
          )
            ? true
            : false;
        }
        if (this.dataview["view_by"].length < 2) {
          this.selectedDataView =
            this.dataview["view_by"][0] === "values" ? "Values" : "YoY%";
        } else {
          this.selectedDataView = "Values,YoY%";
        }
      } else {
        for (let i = 0; i < 2; i++) {
          this.checkOptions[i].checked = false;
        }
        this.radioValue = this.dataview["revision"];
      }
    }
  }

  /**
   * This method resets the selection of the growth revision filter to the default values or the values that have been saved.
   */
  onResetDataView() {
    this.dataViewFilterVisible = false;
    if (this.isIndustryPage) {
      this.radioValue = "";
      this.checkOptions = [
        { label: "Values", value: "values", checked: true },
        { label: "YoY%", value: "yoy", checked: false },
      ];
      this.selectedDataView = "Values";
      this.setDataView("", ["values"]);
    } else {
      if (this.dataview && this.dataview["view_by"][0] !== "revision") {
        this.radioValue = "";
        for (let i = 0; i < 2; i++) {
          this.checkOptions[i].checked = this.dataview["view_by"].includes(
            this.checkOptions[i].value,
          )
            ? true
            : false;
        }
        if (this.dataview["view_by"].length < 2) {
          this.selectedDataView =
            this.dataview["view_by"][0] === "values" ? "Values" : "YoY%";
        } else {
          this.selectedDataView = "Values,YoY%";
        }
      } else {
        for (let i = 0; i < 2; i++) {
          this.checkOptions[i].checked = false;
        }
        this.radioValue = this.dataview["revision"];
      }
    }
  }

  chkboxOptChange() {
    this.radioValue = "";
  }

  /**
   * This is the onchange method for the ant radio component
   * where we set checked flag for each option
   * based on the selection made
   */
  radioValChange() {
    this.checkOptions.map((option) => {
      option.checked = false;
      return { ...option };
    });
  }

  /**
   * This method is fired on clicking the apply button.
   *
   *
   * This is useful to verify if ther user has made valid selections on the filter
   * before applying and sets the error message accordingly.
   *
   */
  applyDataView() {
    let viewBy = [];
    if (
      !this.radioValue &&
      !this.checkOptions[0].checked &&
      !this.checkOptions[1].checked
    ) {
      this.invalidDataview = true;
      this.dvErrMsg = "Please select a value";
    } else {
      this.invalidDataview = false;
      this.dvErrMsg = "";
      if (this.radioValue !== "") {
        let revision = "";
        // let dateStr = "";
        viewBy = ["revision"];
        switch (this.radioValue) {
          case "1y":
            this.selectedDataView = "&Delta; 1 year";
            //  revision = `1m|${dateStr.toString()}`;
            revision = `1y`;
            break;
          case "2y":
            this.selectedDataView = "&Delta; 2 years";
            revision = `2y`;
            break;
          default:
            break;
        }
        this.setDataView(revision, viewBy);
      } else {
        //console.log(this.checkOptions);
        if (this.checkOptions[0].checked && this.checkOptions[1].checked) {
          this.selectedDataView = "Values,YoY%";
          this.setDataView("", ["values", "yoy"]);
        } else {
          if (this.checkOptions[0].checked) {
            this.selectedDataView = this.checkOptions[0].label;
            this.setDataView("", ["values"]);
          }
          if (this.checkOptions[1].checked) {
            this.selectedDataView = this.checkOptions[1].label;
            this.setDataView("", ["yoy"]);
          }
        }
      }
    }

    //this.inValidCustomDate
  }

  /**
   * This method is used to emit the value(output) of the filter as an input to the parent component.
   * @param revision revision value chosen by the user
   * @param viewBy either values or revision
   */
  setDataView(revision, viewBy) {
    this.dataViewFilterVisible = false;
    this.dataviewApplied = true;
    this.saveDataview.emit({ viewBy, revision });
  }
}
